import { cn } from "@/modern/utils";
import {
  ENTITY_FINDER_EMPTY_TITLE_CLS,
  ENTITY_FINDER_HELPER_CLS,
  ENTITY_FINDER_ROW_PADDING,
  ENTITY_FINDER_SUBTITLE_CLS,
  ENTITY_FINDER_TITLE_CLS,
} from "@/modern/components/entity-finder/constants/layout";
import type { EntityFinderConfigEntryRuntime } from "@/modern/components/entity-finder/types";
import { EntityFinderSectionHeader } from "@/modern/components/entity-finder/components/EntityFinderList";
import { EntityFinderHighlight } from "@/modern/components/entity-finder/components/EntityFinderHighlight";
import { entityFinderIconShellClass, entityFinderTintText } from "@/modern/components/entity-finder/components/EntityFinderItemRow";
import { EntityFinderListItem } from "@/modern/components/entity-finder/components/EntityFinderListItem";
import { renderEntityFinderConfigIcon } from "@/modern/components/entity-finder/components/renderEntityFinderConfigIcon";

interface EntityFinderCreateActionsProps {
  query: string;
  options: Array<{ entry: EntityFinderConfigEntryRuntime; label: string }>;
  onCreate: (entry: EntityFinderConfigEntryRuntime) => void;
  className?: string;
}

export function EntityFinderCreateActions({
  query,
  options,
  onCreate,
  className,
}: EntityFinderCreateActionsProps) {
  return (
    <div className={cn(className)}>
      {options.length > 0 && (
        <section className="pb-2">
          <EntityFinderSectionHeader title="Create new" isFirst />
          <div>
            {options.map(({ entry, label }) => (
                <EntityFinderListItem
                  key={`create-${entry.type}`}
                  value={`create-${entry.type}-${query}`}
                  onSelect={() => onCreate(entry)}
                >
                  <div className={cn("flex w-full items-center gap-3", ENTITY_FINDER_ROW_PADDING)}>
                    <div className={entityFinderIconShellClass(false, entityFinderTintText(entry.tint))}>
                      {renderEntityFinderConfigIcon(entry.icon, 14, "text-sm")}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className={cn("truncate", ENTITY_FINDER_TITLE_CLS)}>{label}</div>
                      <p className={cn("mt-0.5 truncate", ENTITY_FINDER_SUBTITLE_CLS)}>
                        &ldquo;
                        <EntityFinderHighlight text={query} query={query} tone="muted" />
                        &rdquo;
                      </p>
                    </div>
                  </div>
                </EntityFinderListItem>
              ))}
          </div>
        </section>
      )}

      <div className="px-4 py-3 text-center">
        <p className={ENTITY_FINDER_EMPTY_TITLE_CLS}>No results</p>
        <p className={cn("mt-0.5", ENTITY_FINDER_HELPER_CLS)}>
          {query
            ? `Nothing matches "${query}". Try a different keyword.`
            : "Start typing to search across your workspace."}
        </p>
      </div>
    </div>
  );
}
